import { tss } from "tss-react/mui";

export const useHeroSectionStyles = tss.withName("HeroSection").create(({ theme }) => ({
    root: {
        position: "relative" as const,
        height: "88vh",
        minHeight: 560,
        overflow: "hidden",
        color: theme.palette.common.white,
    },
    imageWrapper: {
        position: "absolute" as const,
        inset: 0,
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover" as const,
    },
    overlay: {
        position: "absolute" as const,
        inset: 0,
        background: "linear-gradient(0deg, rgba(24,18,13,0.75) 0%, rgba(24,18,13,0.15) 45%, rgba(24,18,13,0.35) 100%)",
    },
    content: {
        position: "relative" as const,
        height: "100%",
        display: "flex",
        flexDirection: "column" as const,
        justifyContent: "flex-end",
        maxWidth: "1640px",
        margin: "0 auto",
        padding: "0 4% 88px",
        [theme.breakpoints.down("sm")]: {
            padding: "0 6% 56px",
        },
    },
    overline: {
        color: theme.palette.common.white,
        marginBottom: theme.spacing(3),
        display: "inline-flex",
        "&::before": {
            backgroundColor: theme.palette.common.white,
        },
    },
    title: {
        maxWidth: 780,
        marginBottom: theme.spacing(3),
    },
    subtitle: {
        maxWidth: 480,
        marginBottom: theme.spacing(5),
        color: "rgba(255,255,255,0.85)",
        lineHeight: 1.7,
    },
    cta: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.text.primary,
        "&:hover": {
            backgroundColor: theme.palette.primary[50],
        },
    },
}));
